<!-- =========================================================================================
  File Name: LogReportView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">

    <vs-table ref="table"  pagination :max-items="itemsPerPage" search
              :data="data">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <!-- ITEMS PER PAGE -->
        <vs-button @click.native="getInviteLog()" class="dd-actions cursor-pointer mb-4">Invites Log</vs-button>
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ data.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : data.length }} of {{ queriedCamUsers }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>


            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=50">
              <span>50</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>


      <template slot="thead">
        <vs-th sort-key="fname">By</vs-th>
        <vs-th sort-key="object_type">Object</vs-th>
        <vs-th>Activity</vs-th>
        <vs-th>Date</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>

        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

          <vs-td>
            <p class="product-name font-medium truncate">{{ tr.user.fname }} {{ tr.user.lname }} </p>
          </vs-td>

          <vs-td>
            <p  class="product-name font-medium truncate">{{ tr.object_type | setFormate }} {{ ' - ' + tr.object_id }} </p>
          </vs-td>
          <vs-td>
            <p class="product-name font-medium truncate">{{ tr.activity }} </p>

          </vs-td>
          <vs-td>
            <p  class="product-name font-medium truncate">  {{ tr.activity === 'added' ? tr.created_at : tr.updated_at | formatDates }}</p>
          </vs-td>


        </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <div class="demo-alignment">
      <div class="fill-row-loading">
        <div :class="{'activeLoading':activeLoading}"  :id="[`loading-sound`]" class="vs-con-loading__container loading-example">
        </div>
      </div>
    </div>
      <div class="demo-alignment">
      <vs-popup fullscreen title="" :active.sync="InvitePopup">
        <div class="centerx">
    <vs-popup class="holamundo" title=" "  :active.sync="popupView">
      <p v-html="View"></p>
    </vs-popup>
  </div>
        <div id="data-list-list-view" class="data-list-container">
        <vs-table ref="table"  pagination :max-items="itemsPerPage" search :data="Invited_data">
      <template slot="thead">
        <vs-th>Status</vs-th>
        <vs-th>Type</vs-th>
        <vs-th>Sender</vs-th>
        <vs-th>Receiver</vs-th>
        <vs-th>Message</vs-th>
        <vs-th>Date</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>

        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
            <p class="product-name font-medium truncate">{{ tr.status }}  </p>
          </vs-td>
            <vs-td>
            <p class="product-name font-medium truncate">{{ tr.type }}  </p>
          </vs-td>

          <vs-td>
            <p  class="product-name font-medium truncate">{{ tr.invited_by.fname }} {{ tr.invited_by.lname }} </p>
          </vs-td>
          <vs-td>
            <p class="product-name font-medium truncate">{{ tr.receiver }} </p>

          </vs-td>
            <vs-td>
             <vs-chip><span @click="Viewdata(tr.message)">View</span></vs-chip>
              <!-- <feather-icon icon="EyeIcon" @click="Viewdata(tr.message)" svgClasses="h-4 w-4" class="mr-2 "/> -->
            <!-- <p v-if="tr.type=='email'"  class="product-name font-medium truncate" ></p>
            <p v-else class="product-name font-medium truncate"  @click="Viewdata(tr.message)">{{tr.message}}</p> -->
          </vs-td>
          <vs-td>
            <p  class="product-name font-medium truncate">  {{  tr.created_at | formatDates }}</p>
          </vs-td>


        </vs-tr>
        </tbody>
      </template>
    </vs-table>  
       <!-- <vs-table  :data="Invited_data">
      <template slot="thead">
        <vs-th>Type</vs-th>
        <vs-th>Sender</vs-th>
        <vs-th>Receiver</vs-th>
        <vs-th>Message</vs-th>
        <vs-th>Date</vs-th>
      </template>

      <template >
        <tbody>
        <vs-tr  :key="indextr" v-for="(tr, indextr) in Invited_data">
          <vs-td>
            <p class="product-name font-medium truncate">{{ tr.type }}  </p>
          </vs-td>

          <vs-td>
            <p  class="product-name font-medium truncate">{{ tr.invited_by.fname }} {{ tr.invited_by.lname }} </p>
          </vs-td>
          <vs-td>
            <p class="product-name font-medium truncate">{{ tr.receiver }} </p>

          </vs-td>
            <vs-td>
            <p class="product-name font-medium truncate">{{ tr.message }} </p>

          </vs-td>
          <vs-td>
            <p  class="product-name font-medium truncate">  {{  tr.created_at }}</p>
          </vs-td>


        </vs-tr>
        </tbody>
      </template>
    </vs-table> -->
  </div>
      </vs-popup>
  </div>
  </div>
</template>

<script>

import 'flatpickr/dist/flatpickr.css'
import {GET_LOG_REPORT, GET_INVITED_LOG_REPORT} from '@/graphql'
import moment from 'moment'


export default {

  data () {
    return {

      data:[],

      itemsPerPage: 10,
      isMounted: false,
      activeLoading:false,
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      passwordSidebarData:{},
      InvitePopup:false,
      Invited_data:[],
      popupView:false,
      View:''
    }
  },
  filters: {
    setFormate (value) {
      if (value) {
        return value.slice(11)
      }
    },
    formatDates (value) {
      if (value) {
        return moment.utc(value).local().format('MM/DD/YYYY h:mm A');
        // return moment(String(value)).format('MM/DD/YYYY h:mm A')
      }
    }

  },
  computed: {

    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },

    select () {
      return this.selected.length
    },
    queriedCamUsers () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.data.length
    }
  },
  methods: {
    Viewdata (msg) {
      this.popupView = true
      this.View = msg
    },
    getInviteLog () {
      this.InvitePopup = true

    },
    getStatusColor (val) {
      if (val === true) {
        return 'success'
      } else {
        return 'grey'
      }
    },
    getReportDetail () {
      this.$apollo
        .mutate({
          mutation: GET_LOG_REPORT
        })
        .then(response => {
          this.data = response.data.getLogReport
          this.activeLoading = false
          this.$vs.loading.close()

        })

    },
    getInvitedDetail () {
      this.$apollo
        .mutate({
          mutation: GET_INVITED_LOG_REPORT
        })
        .then(response => {
          this.Invited_data = response.data.getInvitedLogReport
        })

    }

  },
  created () {
    this.img_cdn = process.env.VUE_APP_IMAGES_CDN_LINK
    this.getReportDetail()
    this.getInvitedDetail()

  },
  mounted () {
    this.isMounted = true
  },
  beforeCreate () {
    this.activeLoading = true
    this.$vs.loading({
      type:'sound'
    })
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .user_add_btn{
    float: right ;
    margin-top: -50px
  }
  @media (max-width: 461px) {
    .user_add_btn {
      margin-top: 60px
    }
  }
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
